/**
 * Ukupna cijena stavki gost-narudžbe. Paket nosi izbore u `prilog[]`, a `price` izbora je doplata ZA JEDAN komad;
 * cijena paketa ne sadrži doplate. Oblik podataka zavisi od toga ko je naručio:
 *   gost (nema line_type):   quantity izbora je UKUPNA (server je izjednači sa količinom paketa)
 *     ukupno stavke = cijena paketa × količina paketa + zbir (price × quantity) izabranih jela
 *   radnik (ima line_type):  quantity izbora je za JEDAN paket
 *     ukupno stavke = (cijena paketa + zbir (price × quantity) izabranih jela) × količina paketa
 * Primjer: 2 paketa po 2650, doplata 200 → gost 2650 × 2 + 200 × 2 = 5700; radnik (2650 + 200 × 1) × 2 = 5700.
 */
const amount = (price, quantity) =>
  (parseFloat(price) || 0) * (parseFloat(quantity) || 0);

const isWorkerLine = (transaction) => Boolean(transaction?.line_type);

/**
 * Ukupna količina jednog izabranog jela (za kuhinju, pakovanje i prikaz):
 * kod gosta je `quantity` već ukupna, kod radnika je `quantity` × količina paketa.
 */
export const choiceQuantity = (transaction, choice) => {
  const quantity = Number(choice?.quantity) || 0;
  return isWorkerLine(transaction) ? quantity * (Number(transaction.quantity) || 0) : quantity;
};

export const transactionTotal = (transaction) => {
  if (!transaction) {
    return 0;
  }
  const choices = Array.isArray(transaction.prilog) ? transaction.prilog : [];
  const choicesSum = choices.reduce(
    (sum, choice) => sum + amount(choice.price, choice.quantity),
    0
  );
  const packagePrice = parseFloat(transaction.price) || 0;
  const packageQuantity = parseFloat(transaction.quantity) || 0;
  return isWorkerLine(transaction)
    ? (packagePrice + choicesSum) * packageQuantity
    : packagePrice * packageQuantity + choicesSum;
};

export const transactionsTotal = (transactions) =>
  (Array.isArray(transactions) ? transactions : []).reduce(
    (sum, transaction) => sum + transactionTotal(transaction),
    0
  );

export const orderTotal = (order) => transactionsTotal(order?.order_guest_transactions);
